import {
  PUBLIC_URL,
  REACT_APP_RINGCENTRAL_EMBEDDABLE_URL,
  REACT_APP_RINGCENTRAL_ENABLED,
  REACT_APP_RINGCENTRAL_SERVER,
  REACT_APP_RINGCENTRAL_CLIENT_ID,
  REACT_APP_RINGCENTRAL_REDIRECT_URI,
} from '../../../../../constants/envConstants';

/** Injected via stylesUri — RC iframe is HTTPS so http:// localhost CSS is blocked (mixed content). */
export const RING_CENTRAL_UI_HIDE_CSS = `
button[data-sign="log"],
[class*="call-item-action-menu"] > button[data-sign="log"],
[class*="call-item-action-menu"] > button:first-child,
.call-item-action-menu button[title="CRM"],
.call-item-action-menu button[aria-label="CRM"],
button:has(span.new-action.icon) {
  display: none !important;
  visibility: hidden !important;
  width: 0 !important;
  min-width: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden !important;
  pointer-events: none !important;
  opacity: 0 !important;
}
`;

const buildRingCentralFileStylesUri = () => {
  const publicPath = (PUBLIC_URL || '').replace(/\/$/, '');
  return `${window.location.origin}${publicPath}/ringcentral-softphone-overrides.css`;
};

const buildRingCentralInlineHideStylesUri = () =>
  `data:text/css;charset=utf-8,${encodeURIComponent(RING_CENTRAL_UI_HIDE_CSS)}`;

export const buildRingCentralStylesUri = () => {
  if (typeof window === 'undefined') {
    return buildRingCentralFileStylesUri();
  }

  if (window.location.protocol === 'http:') {
    return buildRingCentralInlineHideStylesUri();
  }

  return buildRingCentralFileStylesUri();
};

export const buildRingCentralSoftphoneUrl = () => {
  const baseUrl = REACT_APP_RINGCENTRAL_EMBEDDABLE_URL;

  const query = new URLSearchParams();

  if (REACT_APP_RINGCENTRAL_CLIENT_ID) {
    query.set('clientId', REACT_APP_RINGCENTRAL_CLIENT_ID);
  }

  const appServer = REACT_APP_RINGCENTRAL_SERVER?.trim().replace(/\/$/, '');
  if (appServer) {
    query.set('appServer', appServer);
  }

  if (REACT_APP_RINGCENTRAL_REDIRECT_URI) {
    query.set('redirectUri', REACT_APP_RINGCENTRAL_REDIRECT_URI);
  }

  query.set('disableMeeting', 'true');
  query.set('disableGlip', 'true');
  query.set('disableMessages', 'true');
  query.set('disableReadText', 'true');
  query.set('defaultCallWith', 'browser');
  query.set('enableFromNumberSetting', '1');
  query.set('disconnectInactiveWebphone', '0');
  query.set('disableInactiveTabCallEvent', '1');
  query.set('enableLoadMoreCalls', '1');
  query.set('defaultAutoLogCallEnabled', '0');

  if (typeof window !== 'undefined') {
    query.set('stylesUri', buildRingCentralStylesUri());
  }

  const qs = query.toString();
  return qs ? `${baseUrl}?${qs}` : baseUrl;
};

export const isRingCentralConfigured = () =>
  Boolean(REACT_APP_RINGCENTRAL_CLIENT_ID);

export const isRingCentralTenantEnabled = () => {
  try {
    const details = JSON.parse(
      localStorage.getItem('client_details') || '{}'
    ) as { ring_central_enable?: number | string };
    return parseInt(String(details?.ring_central_enable ?? 0), 10) === 1;
  } catch {
    return false;
  }
};

export const isRingCentralEnabled = () =>
  Boolean(
    REACT_APP_RINGCENTRAL_ENABLED &&
      isRingCentralConfigured() &&
      isRingCentralTenantEnabled()
  );
